import { Table, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { colors, fade, withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme: any) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: '#f4f6f8',
    },
  },
});
const stylesBlue = () => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(colors.blue[300], 0.13),
    },
  },
});
const stylesGreen = () => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(colors.green[300], 0.1),
    },
  },
});
const stylesRed = () => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(colors.red[300], 0.1),
    },
  },
});
const stylesOrange = () => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(colors.orange[300], 0.1),
    },
  },
});
const stylesPurple = () => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(colors.deepPurple[300], 0.1),
    },
  },
});
const stylesGrey = () => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: '#f4f6f8',
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <VirtualTable.Table {...restProps} className={classes.tableStriped} />
);
const TableComponentBase2 = ({ classes, ...restProps }) => (
  <Table.Table
    {...restProps}
    className={classes.tableStriped}
    style={{ borderWidth: 4, borderLeftColor: 'blue' }}
  />
);
export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export const TableComponent2 = withStyles(styles, { name: 'TableComponent2' })(
  TableComponentBase2
);
export const TableComponentBlue = withStyles(stylesBlue, {
  name: 'TableComponent',
})(TableComponentBase);
export const TableComponentGreen = withStyles(stylesGreen, {
  name: 'TableComponent',
})(TableComponentBase);
export const TableComponentRed = withStyles(stylesRed, {
  name: 'TableComponent',
})(TableComponentBase);
export const TableComponentOrange = withStyles(stylesOrange, {
  name: 'TableComponent',
})(TableComponentBase);
export const TableComponentPurple = withStyles(stylesPurple, {
  name: 'TableComponent',
})(TableComponentBase);
export const TableComponentGrey = withStyles(stylesGrey, {
  name: 'TableComponent',
})(TableComponentBase);
